interface ScrollToItemProps {
  itemPosition: number;
  offset?: number;
  grid?: boolean;
}

export const galleryScrollToItem = ({
  itemPosition,
  offset = 68,
  grid = false,
}: ScrollToItemProps) => {
  const element: HTMLElement | null = document.querySelector(
    `[data-gallery-item-position${grid ? '-grid' : ''}="${itemPosition}"]`
  );

  if (element) {
    const rect = element.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    window.scrollTo({
      top: rect.top + scrollTop - offset,
      // behavior: 'smooth', // Nepoužívat - zbytečně načítá průběžné fotky
    });
  }
};
